export const isNonShapeWesgroupTenant = (tenantName: string): boolean => {
  return (
    tenantName !== 'Shape' &&
    tenantName !== 'ShapeRC' &&
    tenantName !== 'Wesgroup'
  );
};

export const isShapeTenantWithStaffRole = (
  tenantName: string,
  userRole: string
): boolean => {
  const isShapeTenant: boolean =
    tenantName === 'Shape' || tenantName === 'ShapeRC';

  const isStaffRole: boolean =
    userRole !== 'Home Owner' && userRole !== 'Occupant';

  return isShapeTenant && isStaffRole;
};

export const shouldShowScheduling = (
  showTimeslots: boolean,
  tenantName: string,
  userRole: string
): boolean => {
  if (!showTimeslots) {
    return false;
  }

  if (tenantName === 'Anthem') {
    return false;
  }

  return (
    isNonShapeWesgroupTenant(tenantName) ||
    isShapeTenantWithStaffRole(tenantName, userRole)
  );
};

const isMissingRequiredAttachment = (theme: string, formData: any): boolean => {
  const themeRequiresAttachment: boolean =
    theme === 'ShapeRC' || theme === 'Shape' || theme === 'Wesgroup';

  if (!themeRequiresAttachment) {
    return false;
  }

  const hasNoAttachments: boolean =
    !formData.srAttachments || !(formData.srAttachments.length > 0);

  return hasNoAttachments;
};

export const isSubmitDisabledByTenantRules = (
  theme: string,
  tenantName: string,
  userRole: string,
  formData: any
): boolean => {
  const isFormwerks: boolean = localStorage.getItem('theme') === 'Formwerks';

  const requiresSchedulePreference: boolean =
    !isFormwerks &&
    !formData.schedulePreferences &&
    isNonShapeWesgroupTenant(tenantName) &&
    tenantName !== 'Anthem';

  if (requiresSchedulePreference) {
    return true;
  }

  if (isNonShapeWesgroupTenant(tenantName)) {
    return false;
  }

  if (tenantName !== 'Wesgroup' && isShapeTenantWithStaffRole(tenantName, userRole)) {
    return false;
  }

  return isMissingRequiredAttachment(theme, formData);
};